import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/landing/Navbar';
import Footer from '../components/landing/Footer';
// LandingLayout.js
function LandingLayout({ user }) { // استلم الـ user هنا
  return (
    <>
      <Navbar user={user} /> {/* مرره هنا */}
      <Outlet />
      <Footer />
    </>
  );
}

export default LandingLayout;
